import { lazy, Suspense, useCallback, useState } from 'react';

import { rem, Drawer, DrawerContent, IconButton } from '@vimeo/bokeh';
import { SettingsGear } from '@vimeo/bokeh-icons';
import { translations } from '@vimeo/cloud-live/translations';
import { BokehTooltip } from '@vimeo/live-core/components/bokeh';

const InteractionDebugContent = lazy(() =>
  import('./InteractionDebugContent').then((m) => ({
    default: m.InteractionDebugContent,
  })),
);

export function InteractionDebugTool() {
  const [isDebugModalShown, setIsDebugModalShown] = useState(false);

  const onToggleDebugModal = useCallback(() => {
    setIsDebugModalShown((it) => !it);
  }, []);

  return (
    <Suspense fallback={null}>
      <BokehTooltip label={translations.debug} shouldWrapChildren={false} placement={'left'}>
        <IconButton
          aria-label={'debug'}
          size={'xs'}
          variant={'tertiary'}
          icon={<SettingsGear />}
          position={'absolute'}
          bottom={rem(16)}
          right={rem(16)}
          onClick={onToggleDebugModal}
        />
      </BokehTooltip>

      <Drawer isOpen={isDebugModalShown} placement={'right'} onClose={onToggleDebugModal}>
        <DrawerContent padding={rem(16)}>
          <InteractionDebugContent onDismiss={onToggleDebugModal} />
        </DrawerContent>
      </Drawer>
    </Suspense>
  );
}
